<template>
  <DuEmpty v-bind="$attrs" :image="image || linjieEmptyImage" />
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { defineProps } from "vue";
import { DuEmpty } from "dangoui";
import linjieEmptyImage from "@/assets/linjie-empty.png";

defineProps({
  image: {
    type: String,
    default: "",
  },
});
</script>
